import React from 'react';

import GenHelps from './GenHelps';
import DisplayDetails from './DisplayDetails';

export default (props) => <>
  <GenHelps {...props} />
  <DisplayDetails {...props} />
</>;
